import User from '@Types/inner/User'

export const dummyUser = {
  useDummyUser: false,
  user: {
    id: 'test',
    isLogin: true,
    isGroupId: false,
    isSnsId: false,
    isRealName: true,
    isKorean: true,
    userNickName: '테스트',
    userOld: 20,
    connectTime: new Date().getTime(),
  } as User,
}
